// R8 — **`useShelfOverflow`, EXTRACTED, AND IT IS THE ARROWS ON EVERY SHELF A MEMBER SCROLLS.**
//
// It decides whether the Library's and My Room's slide arrows are LIT, and whether a tap on one
// moves the row far enough to be worth the tap. Three call sites, one behaviour, and inside
// `src/App.tsx` no gate could ever load it.
//
// **IT HOLDS HOOKS, SO IT IS THE `TierCards` / `MicButton` CLASS RATHER THAN A HOOKLESS LEAF A GATE
// CALLS — and the reach it buys is the IMPORT.** A fixture can read the one thing that matters about
// this hook without a browser: the two four-pixel tolerances and the 0.8 slide fraction that decide
// whether an arrow at the very end of a row reads as lit, which is the class W5-2's shelf arithmetic
// is about.
//
// Moved VERBATIM: not a character of the body changed, so the round's render risk is carried by the
// build, the typecheck and the gate rather than by a claim.
import { useEffect, useRef, useState } from "react";

export function useShelfOverflow(count: number, minSlide: number) {
  const booksRef = useRef<HTMLDivElement>(null);
  const [overflow, setOverflow] = useState({ left: false, right: false });
  const updateOverflow = () => {
    const el = booksRef.current;
    if (!el) return;
    const maxScroll = el.scrollWidth - el.clientWidth;
    setOverflow({ left: el.scrollLeft > 4, right: el.scrollLeft < maxScroll - 4 });
  };
  useEffect(() => {
    updateOverflow();
    const el = booksRef.current;
    if (!el) return;
    el.addEventListener("scroll", updateOverflow, { passive: true });
    window.addEventListener("resize", updateOverflow);
    const t = window.setTimeout(updateOverflow, 300); // after images/layout settle
    return () => { el.removeEventListener("scroll", updateOverflow); window.removeEventListener("resize", updateOverflow); window.clearTimeout(t); };
  }, [count]);
  const slide = (dir: number) => {
    const el = booksRef.current;
    if (el) el.scrollBy({ left: dir * Math.max(minSlide, el.clientWidth * 0.8), behavior: "smooth" });
  };
  return { booksRef, overflow, slide };
}
